import React from "react";
import { useNavigate } from "react-router-dom";
import Placeholder from "../components/Placeholder";
import { LOGO_NASA, FLAGS } from "@/assets/images";
import EditableImage from "../components/EditableImage";
import Footer from "../components/Footer";
import { HANDLE, NAME, LOCATION } from "../config";

const ROLES = [
  "👥 Founder - NAŠA Community",
  "🟥 Motivational Speaker",
  "🟦 Crypto Expert",
  "🔶 Community Builder",
];

const LANG_ROWS = [
  { code: "sr", flag: "🇷🇸", title: "Izaberi jezik", sub: "(klikni na zastavu)" },
  { code: "it", flag: "🇮🇹", title: "Scegli la lingua", sub: "(clicca sulla bandiera)" },
  { code: "en", flag: "🇬🇧", title: "Choose language", sub: "(click the flag)" },
];

export default function Entry() {
  const navigate = useNavigate();

  return (
    <div className="portal" data-testid="entry-page">
      <div className="flex flex-col items-center gap-1 fade-up">
        <img
          src={LOGO_NASA}
          alt="NAŠA.com"
          style={{ width: 240, height: "auto", display: "block" }}
          data-testid="entry-logo"
        />
        <div style={{ fontWeight: 600, marginTop: 4 }} data-testid="entry-handle">
          {HANDLE}
        </div>
      </div>

      <div className="card fade-up" style={{ animationDelay: "0.08s" }} data-testid="entry-card">
        <EditableImage
          storageKey="entry-profile"
          label="PHOTO 1 — profile"
          style={{ width: "100%", height: 260 }}
          data-testid="entry-photo"
        />

        <h1
          style={{ fontSize: 30, fontWeight: 800, textAlign: "center", margin: "18px 0 6px" }}
          data-testid="entry-name"
        >
          {NAME}
        </h1>
        <p style={{ textAlign: "center", color: "var(--ink-soft)", margin: 0 }} data-testid="entry-location">
          {LOCATION}
        </p>

        <div style={{ marginTop: 16, display: "flex", flexDirection: "column", gap: 6 }} data-testid="entry-roles">
          {ROLES.map((r) => (
            <div key={r} style={{ fontWeight: 500 }}>
              {r}
            </div>
          ))}
        </div>

        <div style={{ height: 1, background: "var(--ink)", opacity: 0.15, margin: "22px 0" }} />

        <div style={{ display: "flex", flexDirection: "column", gap: 14 }} data-testid="lang-selector">
          {LANG_ROWS.map((row) => (
            <button
              key={row.code}
              onClick={() => navigate(`/${row.code}`)}
              data-testid={`lang-select-${row.code}`}
              style={{
                display: "flex",
                alignItems: "center",
                gap: 14,
                background: "transparent",
                border: "none",
                cursor: "pointer",
                fontFamily: "inherit",
                textAlign: "left",
                padding: 0,
              }}
            >
              <img
                src={FLAGS[row.code]}
                alt={row.title}
                style={{ width: 62, height: 44, objectFit: "cover", borderRadius: 6, flex: "0 0 auto", border: "1px solid rgba(0,0,0,0.1)" }}
                data-testid={`lang-flag-${row.code}`}
              />
              <span>
                <span style={{ display: "block", fontWeight: 600, color: "var(--ink)" }}>
                  {row.title}
                </span>
                <span style={{ display: "block", fontSize: 13, color: "var(--ink-soft)" }}>
                  {row.sub}
                </span>
              </span>
            </button>
          ))}
        </div>
      </div>

      <Footer testid="entry-footer" />
    </div>
  );
}
